import React, { ImgHTMLAttributes, DetailedHTMLProps } from 'react';

import cn from 'classnames';
import { useNavigate } from 'react-router-dom';

import arrow from 'assets/images/arrow-left.svg';
import './BackArrow.scss';
import { Paths } from 'enums';

type BackArrowPropsType = DetailedHTMLProps<
  ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
> & {
  className?: string;
  path?: Paths;
};

export const BackArrow = ({ className, path, ...rest }: BackArrowPropsType) => {
  const navigate = useNavigate();

  const onClick = (path?: Paths) => {
    if (path) {
      navigate(path);
    } else {
      navigate(-1);
    }
  };

  return (
    <img
      src={arrow}
      className={cn('BackArrow', className)}
      alt="arrow-left"
      onClick={() => onClick(path)}
      {...rest}
    />
  );
};
